// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"Zba-z"};